Jelly.Utilities.Format = function(Content, Format) {	
	
	var Formatted_Content = Content; 
	
	// For any text processing we have to do often.
	switch (Format.toLowerCase()) {
		case "alias":

			// Replace certain strings
			Formatted_Content = Content.replace(/(&|[\+])/g, "and");
			
			// Replace groups of punctuation with an underscore
			Formatted_Content = Formatted_Content.replace(/[( )\-_\.]+/g, "_");
			
			// Remove non alphanumerics/underscores
			Formatted_Content = Formatted_Content.replace(/[^\w]+/g, "");
			
			// Replace underscore groups with single underscore
			Formatted_Content = Formatted_Content.replace(/[_]+/g, "_");

			// Trim trailing or leading underscores
			Formatted_Content = Formatted_Content.trim();
			break;
	}

	return Formatted_Content;
};